import TipComponent from '../TipComponent.vue'

export default [
    {
        path: '/tips',
        component: TipComponent,
        name: 'tips'
    }
]